<template>
  <div class="platform-navbar">
    <div class="header-left">
      <SideNavToggle v-if="isNotSharePage" class="mr-4" />
      <router-link
        v-if="isNotSharePage"
        :to="{ name: 'root' }"
        class="datapeople-logo-link"
        @click="$emit('tracking-event', { action: 'homeLogoClicked' })"
      >
        <img
          src="@/assets/png/payscale-light.png"
          alt="Job Nav logo"
        >
      </router-link>
      <img
        v-else
        src="@/assets/png/payscale-light.png"
        alt="Job Nav logo"
        class="datapeople-logo-link"
      >
    </div>
    <DashboardSearchBar
      v-if="isNotSharePage"
      :search-term="searchTerm"
      :light="true"
      always-open
      data-testid="dashboard-search-bar"
      :placeholder="'Search'"
      v-bind="$attrs"
    />
    <SettingsPanel
      v-if="isNotSharePage"
      v-bind="{ ...$attrs }"
    />
  </div>
</template>

<script>
import SideNavToggle from '@/components/shared/sideNav/SideNavToggle.vue';
import DashboardSearchBar from '@/components/shared/DashboardSearchBar.vue';
import SettingsPanel from '@/components/navbar/SettingsPanel.vue';

export default {
  name: 'PlatformNavbar',
  components: {
    SideNavToggle,
    DashboardSearchBar,
    SettingsPanel,
  },
  props: {
    isNotSharePage: { type: Boolean, default: false },
    searchTerm: { type: String, default: '' },
  },
  emits: ['tracking-event'],
};
</script>
<style lang="less" scoped>
.platform-navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 60px;
  width: 100%;
  border-bottom: 1px solid @stroke-default;
  background: linear-gradient(to right, @forest-green, @forest-teal);

  .header-left {
    display: flex;
    align-items: center;
    max-width: 230px; // Safari needs a max-width
  }

  .datapeople-logo-link {
    display: flex;
    height: 20px;
  }
}
</style>
